export default __webpack_public_path__ + "static/media/PowerGrotesk-Light.43739c0a.woff2";